module.exports = {
  tag: 'terror',
  quality: 1.0,
};
